export const GREETING_MESSAGES = [
  // --- Tanda nueva (Junio 2026) — 118 frases ---
  // Marcas SURA con punch
  "si la dedicación fuera moneda, aquí seríamos el Banco Central. 🏦",
  "tu actitud hoy: edición especial, sin parecido a las demás.",
  "como Diva: no hay mal día que sobreviva a tu entrada.",
  "el que dijo 'no se puede' nunca trabajó un viernes contigo.",
  "más rendidor que el último billete antes de quincena. 💸",
  "tu compromiso huele a Adi: dura todo el día, sin reforzar.",
  "si un día tuviera reseñas, el de hoy contigo sería 5 estrellas. ⭐",
  "eres la razón por la que las reuniones de los lunes no son tan malas.",
  "como buena arepa: sencilla por fuera, increíble por dentro. 🫓",
  "tu nivel de foco hoy: ni el wifi lento te detiene.",
  "SURA exporta calidad. Tú exportas buena vibra.",
  "hoy no improvisas, ejecutas. Eso ya es nivel SURA.",
  "tu energía rinde más que detergente concentrado en oferta.",
  "si esto fuera un partido, ya estarías en la foto del equipo campeón. 🏆",
  "eres ese mensaje de 'ya llegué' que todos quieren leer.",
  "hoy tu trabajo silencioso hace ruido en los resultados.",
  "tu efectividad es Premium, pero tu sueldo... bueno, esa conversación es con GH. 😅",
  "si Vale diera medallas por suavidad, tú llevarías la de oro.",
  "Oki absorbe líquidos, tú absorbes responsabilidades. Mismo nivel de campeón.",
  "Adi 48 horas, tú 24/7. Ya casi le ganas.",
  "Fresca por dentro, Diva por fuera, Vale en resultados. Premio para ti, Oki?",
  "tu desempeño viene en frasco grande, no en muestra gratis.",
  "como buen producto SURA: no necesitas publicidad, te recomiendan solo.",
  "si existiera el jabón de la buena actitud, sería el tuyo.",
  "Dalan limpia con cariño. Tú trabajas con la misma fórmula.",
  // Humor venezolano
  "más rápido resolviendo problemas que cambista en esquina un viernes.",
  "naciste pa' resolver. Es un don, no una opción.",
  "más sabroso que un pasapalo en fiesta decembrina.",
  "el venezolano no se rinde, se reinventa. Y hoy tú lo demuestras.",
  // Vida de oficina
  "tu bandeja de entrada en 0 sería noticia nacional. Pero vas bien.",
  "si 'reenviado' fuera un deporte, tú ya tendrías patrocinio.",
  "hoy esa llamada que evitas se va a sentir orgullosa de ti cuando la hagas.",
  "tu Excel tiene más fórmulas que receta de la abuela. Y funciona igual de bien.",
  "eres de los que apaga incendios sin ensuciarse el uniforme.",
  "tu capacidad de fingir que no escuchaste ese chisme: nivel dios.",
  "hoy la fotocopiadora va a portarse bien. Tú te lo ganaste.",
  // Motivacional con filo
  "no necesitas que el día sea fácil. Solo necesitas que valga la pena. Y hoy vale.",
  "el cansancio es temporal. Lo que construyes hoy, no.",
  "deja de pedirle permiso a la duda. Hoy se trabaja con certeza.",
  "no compitas con nadie más que con la versión de ti de ayer. Y ya le vas ganando.",
  "los resultados no mienten, pero el esfuerzo tampoco se esconde.",
  "el miedo toca la puerta, la disciplina abre. Hoy abres tú.",
  "no es el mejor momento. Es el único que tienes. Úsalo bien.",
  "cada 'no se puede' que escuchaste, hoy lo conviertes en evidencia de lo contrario.",
  "tu constancia de hoy es la ventaja que otros no tendrán mañana.",
  "no se trata de tener tiempo. Se trata de hacerle espacio a lo importante. Como tú lo haces.",
  // Tech y modernidad
  "tu mente hoy: multitarea sin lag.",
  "eres ese sistema que nunca falla cuando todos los demás se cuelgan.",
  "tu enfoque está en modo incógnito: nada lo distrae.",
  "eres el 'actualizar y reintentar' que sí funciona a la primera.",
  // Comida y costumbres
  "más completo que un pabellón con todo y tajadas.",
  "como buen tequeño: pequeño detalle, gran impacto en la mesa.",
  "si fueras plato, serías sancocho: con un poco de todo y siempre cae bien.",
  "más esperado que el primer sorbo de café de la mañana.",
  "más confiable que la abuela que siempre tiene algo guardado para ti.",
  "tu trabajo de hoy se sirve con el mismo cariño que una arepa recién hecha.",
  "eres ese cafecito de las 3pm que nadie sabía que necesitaba hasta que llegó.",
  // Compañerismo
  "el que presta su cargador sin preguntar nada, ese es tú. Leyenda silenciosa.",
  "gracias por ser de los que dicen 'yo te cubro' y de verdad cubren.",
  "un equipo no se mide en organigrama, se mide en quién aparece cuando hace falta. Tú apareces.",
  "si alguien necesita una mano hoy, ya sabe a quién buscar primero.",
  "eres de los que celebra el logro ajeno como si fuera propio. Eso escasea.",
  "no se trata de ser el más rápido, sino de no dejar a nadie atrás. Tú lo entiendes.",
  "eres ese mensaje de '¿todo bien?' que llega justo cuando hacía falta.",
  "los grandes equipos los hace la gente que no necesita brillar para hacer brillar a otros. Eso eres tú.",
  // Absurdo con cariño
  "si fueras un superhéroe, tu superpoder sería 'resolver antes del mediodía'.",
  "eres tan eficiente que el reloj te pide permiso para avanzar.",
  "si existiera un manual de 'cómo ser indispensable', tú serías el autor.",
  "tu nivel de carisma hace que hasta las reuniones largas se sientan cortas.",
  "si tu nombre fuera una marca, ya estaríamos vendiendo merchandising.",
  "si existiera un trofeo a 'la persona que todos quieren en su equipo', ya tendrías vitrina propia.",
  "tu nivel de buena suerte hace que hasta el semáforo se ponga verde primero.",
  // Cierre con orgullo
  "lo que entregas hoy no se ve en el inventario, pero se siente en el resultado.",
  "cada turno cumplido aquí es un ladrillo en algo que va a durar más que todos nosotros.",
  "no firmamos solo nómina. Firmamos un compromiso con cada hogar que confía en nosotros.",
  "Venezuela come, se baña y se viste mejor gracias a manos como las tuyas.",
  "esto que parece rutina, en realidad es historia escribiéndose despacito.",
  "el legado de SURA no está en los números. Está en la gente que lo hace posible cada día.",
  "no es solo producción. Es la prueba de que aquí no nos rendimos, mejoramos.",
  "cuando alguien diga 'esto es de calidad', recuerda: ese alguien eres tú, sin saberlo.",
  "lo que construyes hoy, alguien lo va a disfrutar sin saber tu nombre. Así de grande es tu aporte.",
  "gracias por hacer que cada día en SURA valga más de lo que parece a simple vista.",
  // --- Tanda nueva 2 (40 frases) ---
  "hoy el café se sirve solo, pero tu actitud se nota acompañada.",
  "bateas los problemas como si fuera la final del campeonato. Strike no hay aquí.",
  "tu día va de jonrón en jonrón, aunque algunos lo vean como suerte.",
  "tu estado de WhatsApp dice una cosa, pero tu nivel de entrega dice otra: imparable.",
  "respondiste el correo antes que el mensaje del grupo familiar. Eso es prioridad.",
  "tu cara cuando llega notificación de 'reunión en 5 minutos': Oscar garantizado.",
  "si tu actitud fuera planta eléctrica, nunca habría apagón de motivación.",
  "más estable que el internet en horario pico. Y eso ya es mucho decir.",
  "se fue la luz, volvió, y tú ni lo notaste de lo concentrado que estabas.",
  "no hace falta que te crean. Hace falta que lo hagas. Y tú ya lo estás haciendo.",
  "el esfuerzo invisible de hoy es la ventaja visible de la próxima semana.",
  "deja de practicar para el partido. Hoy es el partido.",
  "el progreso no avisa cuándo llega. Por eso hay que estar trabajando cuando toque la puerta.",
  "nadie aplaude el ensayo. Pero sin ensayo no hay función. Sigue ensayando.",
  "lo que hoy parece un detalle sin importancia, en un año puede ser la decisión que lo cambió todo.",
  "no necesitas inspiración. Necesitas la primera tarea lista. Lo demás viene solo.",
  "la disciplina no se siente bien todos los días. Por eso no todos la tienen.",
  "si las pausas para café fueran reunión oficial, tendrías el récord de asistencia perfecta.",
  "si existiera un radar para detectar pereza, contigo cerca no marcaría nada.",
  "si te pagaran por cada vez que salvaste el día sin que nadie se enterara, ya tendrías otro sueldo.",
  "hay gente que suma personas a un proyecto. Tú sumas ganas. Eso vale más.",
  "el ambiente cambia cuando entras al pasillo. Y no es por el perfume.",
  "nadie ve el proceso completo, pero todos disfrutan el resultado. Ese resultado pasó por tus manos.",
  "lo que hoy parece una tarea más, en algún hogar se convierte en algo que realmente necesitaban.",
  "no eres parte del paisaje de la empresa. Eres parte de por qué la empresa sigue de pie.",
  "cuando la historia de SURA se cuente completa, tu nombre va a estar en algún capítulo, aunque no lo sepas.",
  "tu estilo tiene ese toque Diva que no se aprende, se trae de fábrica.",
  "Premio no es solo un nombre. Hoy también es lo que te mereces.",
  "tu actitud fresca hoy le hace honor al nombre de la marca, literal.",
];
